mutation createOrUpdateCancelation($input: CreateOrUpdateCancelationInput!) {
  createOrUpdateCancelation(input: $input)
}
